<template>
  <div>
    <h3>Mis Dispositivos</h3>
    <div v-if="devices.length === 0" class="alert alert-info">No tienes dispositivos asignados.</div>
    <div class="row">
        <div v-for="device in devices" :key="device.id" class="col-12 col-md-6 col-lg-4 mb-3">
        <DeviceCard v-if="device.type === 'switch'" :device="device" />
        <DeviceCard3EM v-else-if="device.type === 'shelly-3em'" :device="device" />
        <!-- Puedes agregar más tipos aquí -->
        <div v-else>
          <b>Tipo no soportado:</b> {{ device.type }}
        </div>
      </div>
    </div>
<button
      class="btn btn-outline-secondary btn-sm"
      @click="logout"
    >
      <i class="bi bi-box-arrow-left"></i> Salir
    </button>



  </div>
</template>

<style>
.logout-fixed {
  position: fixed;
  bottom: 20px;
  left: 20px;
  z-index: 1000;
  /* Puedes ajustar padding o tamaño si quieres */
}
</style>





<script>
import api from "../api/api";
import DeviceCard from "../components/DeviceCard.vue";
import DeviceCard3EM from "../components/DeviceCard3EM.vue";

export default {
  components: { DeviceCard, DeviceCard3EM },
  data() {
    return { devices: [] };
  },
  async mounted() {
    // Consulta solo los dispositivos asignados a este usuario
    const res = await api.myDevices();
    this.devices = res.data;
  },
 methods: {
    logout() {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
  }









};
</script>
